/** Shared UI states for the Speaking recorder in preview and answer flows. */
export var SpeakingRecorderState;

(function (SpeakingRecorderState) {
  SpeakingRecorderState["Init"] = "init";
  SpeakingRecorderState["Permission"] = "permission";
  SpeakingRecorderState["PermissionDenied"] = "permission_denied";
  SpeakingRecorderState["Unsupported"] = "unsupported";
  SpeakingRecorderState["Reserving"] = "reserving";
  SpeakingRecorderState["Preparation"] = "preparation";
  SpeakingRecorderState["Recording"] = "recording";
  SpeakingRecorderState["Recorded"] = "recorded";
  SpeakingRecorderState["Submitted"] = "submitted";
  SpeakingRecorderState["Submitting"] = "submitting";
})(SpeakingRecorderState || (SpeakingRecorderState = {}));